import OpenLayers from 'client/utils/helpers/OpenLayers/OpenLayers';

export const isPointCoordinate = (point) => {
    return Array.isArray(point) &&
        point.length >= 2 &&
        Number.isFinite(point[0]) &&
        Number.isFinite(point[1]);
};

export const areSamePoint = (a, b) => {
    return isPointCoordinate(a) &&
        isPointCoordinate(b) &&
        a[0] === b[0] &&
        a[1] === b[1];
};

export const readGeometryCoordinates = (geometry) => {
    if (!geometry || typeof geometry.getCoordinates !== 'function') {
        return null;
    }

    const coordinates = geometry.getCoordinates();
    return Array.isArray(coordinates) ? coordinates : null;
};

export const exceedsBoundingExtent = (geometry, userLimit) => {
    const extent = geometry?.getExtent?.();
    if (!extent || extent.length !== 4 || !Number.isFinite(userLimit)) {
        return false;
    }

    const width = extent[2] - extent[0];
    const height = extent[3] - extent[1];
    return width > userLimit || height > userLimit;
};

export const getExtentExceeded = ({ geometry, userLimit }) => {
    return OpenLayers.geometry.isGreaterThan(geometry, userLimit);
};

export const getDefaultStyleVariant = ({ isGreaterThan, isValid }) => {
    return !isGreaterThan && isValid
        ? 'default-valid'
        : 'default-error';
};

export const getSketchEdgeStyleVariant = ({ isGreaterThan, isValid, isSketchEdgeGeometry }) => {
    if (isSketchEdgeGeometry) {
        return !isGreaterThan && isValid
            ? 'simple-line-valid'
            : 'simple-line-error';
    }

    return getDefaultStyleVariant({ isGreaterThan, isValid });
};
